import { Grid } from "@material-ui/core";
import { TextField } from "@ofqual/portal-components/components/TextField";
import React from "react";
import { ScopeApplication } from "../../domain/ScopeApplication";
import { SectionProps } from "./SectionProps";
import { Controller } from "react-hook-form";
import { Error } from "../common/Error";

export const ApplicationTitle: React.FC<SectionProps<ScopeApplication>> = ({
  control,
  errors,
  disabled,
}) => {
  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Controller
          control={control}
          name="title"
          rules={{ required: true, maxLength: 200 }}
          as={
            <TextField
              variant="outlined"
              label="Title"
              data-test="application-title"
              fullWidth
              multiline
              readOnly={disabled}
              required
            />
          }
        />
        {errors.title && errors.title.message && (
          <Error>{errors.title.message}</Error>
        )}
        {errors.title?.type === "required" && (
          <Error>This field is required</Error>
        )}
        {errors.title?.type === "maxLength" && (
          <Error>Title must be less than 200 characters</Error>
        )}
      </Grid>
    </Grid>
  );
};
